var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height py-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"fill-height"},[_c('v-col',{staticClass:"d-none d-md-flex signin-image align-stretch",attrs:{"cols":"7"}}),_c('v-col',{attrs:{"sm":"12","md":"5"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }